"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignTexts = void 0;
var useESignTexts_hook_1 = require("./useESignTexts.hook");
Object.defineProperty(exports, "useESignTexts", { enumerable: true, get: function () { return useESignTexts_hook_1.useESignTexts; } });
//# sourceMappingURL=index.js.map